import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "cliente" ? "/calendario" : "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-greige flex items-center justify-center px-6">
      <div className="w-full max-w-sm fade-up">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-ink">TwoeLab</h1>
        <p className="meta-label mt-2 mb-12">CLOUD HUB · GESTIONE BRAND</p>
        <form onSubmit={submit} className="space-y-7">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            data-testid="login-email-input"
            className="field-line"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            data-testid="login-password-input"
            className="field-line"
          />
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-button"
            className="w-full bg-black text-greige py-3.5 text-xs uppercase tracking-widest hover:bg-stone2e transition-colors disabled:opacity-60"
          >
            {busy ? "Accesso in corso…" : "Accedi"}
          </button>
        </form>
        <div className="flex items-center gap-3 my-6">
          <span className="h-px flex-1 bg-black/15" />
          <span className="meta-label">oppure</span>
          <span className="h-px flex-1 bg-black/15" />
        </div>
        <button
          type="button"
          onClick={googleLogin}
          data-testid="google-login-button"
          className="w-full flex items-center justify-center gap-3 border border-black py-3.5 text-xs uppercase tracking-widest hover:bg-black hover:text-greige transition-colors"
        >
          <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.1 18.9 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.6 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.2c-2 1.5-4.6 2.5-7.4 2.5-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4 5.5l6.3 5.2C41.4 36 44 30.5 44 24c0-1.3-.1-2.3-.4-3.5z"/>
          </svg>
          Continua con Google
        </button>
        <p className="font-body text-xs text-stone2e mt-8">
          Password dimenticata? Contatta TwoeLab per la modifica password.
        </p>
      </div>
    </div>
  );
}
